<quill-editor
    class="editor"
    [(ngModel)]="content"
    [class.arabic]="AdaaHelper.getCurrentLang() === Language.Arabic"
    [class.rtl-text]="language() === Language.Arabic"
    [modules]="editorModules"
    (onContentChanged)="change()"
    (onEditorCreated)="onEditorCreated($event)"
    [dir]="language() === Language.Arabic ? 'rtl' : 'ltr'"
></quill-editor>
